import $ from 'jquery';
import _ from 'lodash';

import {
  addClassSvg,
  createDistanceToolTip,
  getParentRotationSetForMarker,
  hideDistanceToolTip,
  pinLocation,
  setAttributes,
} from './helpers';
import { store } from '../../../redux/store';

export function createPin(data, index, svg,hole){
    let state = store.getState();
    let greensDescriptions = state.commonReducers.greensWithPinPlacementStateData
    let viewMeasureFromReduxState = state.firstReducer.viewMeasureFromReduxState;
    let viewActivePinsReduxState = state.firstReducer.activeOnlyReduxState;
    let pinsEditModeReduxState = state.commonReducers.pinsEditModeReduxState;
    let marker = data.Name;
    let r = 8;

    let rotationInfo = (_.filter(_.flatMapDeep(greensDescriptions.RotationSets,'Rotations'), { 'Marker': data.Name }))[0]; // Correct Line
    let formatCircle = {
       stroke: "black",
       "stroke-width": 1,
       fill: "white"
      };
  
     // Initial format object for pin's text.
     let formatText = {
        "text-anchor": "middle",
        "font-size": "11px",
        "font-family": "Times Roman",
        "stroke-width": 0.5
     };
     
     // Add additional formatting based on type of pin placement.
     let rotationSet = getParentRotationSetForMarker(marker,greensDescriptions);
     if ((rotationSet?.Type === "Daily") && (marker !== "*")) {
        // Daily Rotation Pin
        formatCircle.fill = "black";
        formatText.stroke = "white";
     }

     // Create the svg objects
     let group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
     group.setAttribute("class", "pin");
  
     if (!rotationInfo.Active && (viewActivePinsReduxState)) addClassSvg(group, 'hide');

     if (pinsEditModeReduxState) addClassSvg(group, 'draggable');
     group.setAttributeNS(null, "transform", "matrix(1 0 0 1 0 0)");
     group.setAttributeNS(null, "dragx", 0);
     group.setAttributeNS(null, "dragy", 0);
     group.setAttributeNS(null, "origx", data.X);
     group.setAttributeNS(null, "origy", data.Y);
     group.setAttributeNS(null, "data-marker", marker);
     group.setAttributeNS(null, "rotation-name", rotationInfo.DisplayName);

     // Creating Circular Pins
     let circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
     setAttributes(circle, $.extend(formatCircle,{ cx: data.X, cy: data.Y, r: r }));
     circle = group.appendChild(circle);

     // For Marking Numbers on the pins
     let t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
     let textY = Math.floor(data.Y + (r / 2));
     if (marker === "*") {
            textY = textY + 2;
     }

     setAttributes(t, $.extend(formatText, {
        x: data.X,
        y: textY,
     }));
     t.textContent = marker;  // *** TEST setting text with this method to see if it shows up.
     t.setAttributeNS(null, "pointer-events", "none");

     // Set group to be pin or activePin.
     if (marker === "*") addClassSvg(group, "override");
     group.appendChild(t);
     svg.appendChild(group);

     group.addEventListener("mouseover", function (evt) {
      // TODO --  var holeInfo = getHoleForElement(selectedElement, greensDescriptions);
        var rotationName = evt.currentTarget.getAttributeNS(null, 'rotation-name');
        // Need to always use center of current position for pin being hovered over
        var loc = pinLocation(evt.currentTarget,hole);
        createDistanceToolTip(evt.clientX, evt.clientY, loc?.x, loc?.y, hole, rotationName,viewMeasureFromReduxState);
     }, false);
     group.addEventListener("mouseout", function (evt) {
        hideDistanceToolTip();
     }, false);

     return group;
}